import React from 'react';
import cx from 'classnames';

import { 
    Container,
    Row,
} from 'react-bootstrap';

import { useNode, useEditor } from '@craftjs/core';

const ContainerRow = ({ children }) => {
    const { connectors: { connect, drag } } = useNode((state) => ({
        selected: state.events.selected
    }));

    const { query } = useEditor();

    return (
        <>
            <Container
                className={cx({
                    'With-Mark': query.getOptions().enabled
                }, 'Container')} 
                ref={ref => {
                    connect(drag(ref));
                }}
                fluid
            >
                <Row>
                    {children}
                </Row>
            </Container>
        </>
    );
};

ContainerRow.craft = {
    displayName: 'Container'
};

export default ContainerRow;
